import { createContext, useCallback, useContext, useEffect, useRef } from "react";

export const UnsavedContext = createContext(null);

export function useUnsavedChanges(options) {
  const context = useContext(UnsavedContext);
  const id = useRef(Symbol("dirty-editor"));
  const latest = useRef(options);
  latest.current = options;
  useEffect(() => context?.register(id.current, () => latest.current), [context]);
  const requestClose = useCallback(action => context ? context.requestLeave(action, [id.current]) : action(), [context]);
  return { requestClose };
}
